const s = "styles-module__title___JCVeO", t = "styles-module__normal___CFlfV", o = "styles-module__description___DfBHM", e = {
  "terms-and-conditions": "styles-module__terms-and-conditions___bFmz6",
  title: s,
  normal: t,
  description: o,
  "terms-and-conditions-modal": "styles-module__terms-and-conditions-modal___sFAfe"
};
export {
  e as default,
  o as description,
  t as normal,
  s as title
};
